import { useForm } from 'react-hook-form'

import { useCreatePoll } from '@tribeplatform/react-sdk/hooks'

import { I18nShape, useI18n, useStaticIntl } from '../i18n/index.js'

import { PollForm } from './form/PollForm.js'
import type { PollFormValues } from './form/types.js'
import { PollFormActionProps } from './types.js'
import { onError } from './utils.js'

export type CreatePollFormProps = PollFormActionProps

const pollOptionsFactory = ({ $t }: I18nShape) => [
  {
    id: 'option-1',
  },
  {
    id: 'option-2',
  },
]

export function CreatePollForm({
  poll,
  onSuccess,
  onCancel,
}: CreatePollFormProps) {
  const i18n = useI18n()
  const defaultOptions = useStaticIntl(pollOptionsFactory)

  const form = useForm<PollFormValues>({
    defaultValues: {
      title: '',
      options: defaultOptions,
      maxSelections: '1',
    },
  })

  const { mutateAsync: createPoll, isLoading } = useCreatePoll({
    fields: 'all',
    useMutationOptions: {
      onError: onError(i18n),
    },
  })

  const onSubmit = ({
    title,
    options,
    maxSelections,
    opensAt,
    closesAt,
  }: PollFormValues) => {
    createPoll(
      {
        input: {
          title,
          options: options.map(option => ({
            label: option.value,
          })),
          parentEntityId: poll?.entityTypeId,
          parentEntityType: poll?.entityType,
          parentHint: poll?.entityTypeId ? undefined : poll?.parentHint,
          maxSelections: Number(maxSelections),
          closesAt: closesAt?.toUTCString(),
          opensAt: opensAt?.toUTCString(),
        },
      },
      {
        onSuccess(data) {
          onSuccess(data)
        },
      },
    )
  }

  return (
    <PollForm
      form={form}
      onSubmit={onSubmit}
      onCancel={onCancel}
      isLoading={isLoading}
    />
  )
}
